import { identifyMixpanelUser } from '@/analytics/identifyMixpanelUser'
import { withMixpanel } from '@/analytics/withMixpanel'
import { accountQueries } from '@/queries/account'
import { animalQueries } from '@/queries/animal'
import { queryClient } from '@/queries/queryClient'
import { subscriptionQueries } from '@/queries/subscription'
import { hashKey } from '@tanstack/query-core'

// The queries whose data feeds the Mixpanel People profile. Each of these is already
// invalidated (and refetched) by the mutation that changes it — so subscribing to their
// updates re-writes the People profile whenever the underlying data actually lands in the
// cache, with no per-call-site wiring. `identifyMixpanelUser` is debounced, so a burst of
// cache notifications collapses into a single People-profile write.
const peopleProfileQueryKeys = [
  accountQueries.profile().queryKey,
  subscriptionQueries.list().queryKey,
  animalQueries.list().queryKey,
  accountQueries.defaultAddress().queryKey,
].map(hashKey)

/**
 * Re-writes the Mixpanel People profile whenever a profile / subscription / dog / address
 * query updates with fresh data. Install once at app boot; `identifyMixpanelUser` no-ops
 * until a user is logged in, so pre-login updates are harmless.
 */
export const setupPeopleProfileSync = (): void => {
  queryClient.getQueryCache().subscribe((event) => {
    if (event.type !== 'updated' || event.query.state.status !== 'success') return
    if (!peopleProfileQueryKeys.includes(hashKey(event.query.queryKey))) return
    withMixpanel(identifyMixpanelUser)
  })
}
